module.exports = __webpack_public_path__ + "09e94304e62c777de0faaecbf1c99a02.pdf";